export default __webpack_public_path__ + "static/media/5_center.d86b1d04.png";